import {Repository} from '@/repositories/Base/Repository'

class TypeValueRepository extends Repository {
    endpoint = 'mapping/type/value'

    findByFilter(params) {
        return this.$axios.get(`${this.endpoint}/find/by-filter`, {params})
    }
}

export default new TypeValueRepository()